(function() {
  'use strict';

  if (window.WFSFFeed) return;

  const TRUTHS = [
    'WATCH FOR BROKEN SYSTEMS',
    'STAY AWARE',
    'WATCH FOR SMILING FACES',
    'THE WARNING IS THE PRODUCT',
    'NOTHING HERE IS AN ACCIDENT',
    'THE CAMERA IS ALWAYS ON',
    'YOU ARE BEING OBSERVED'
  ];

  const SYSTEM_LINES = [
    'GARMENT_01 :: OBSERVED :: STABLE',
    'GARMENT_02 :: OBSERVED :: STABLE',
    'GARMENT_03 :: HERO SUBJECT :: ELEVATED',
    'GARMENT_04 :: PAIR DETECTED',
    'GARMENT_05 :: PAIR DETECTED',
    'GARMENT_06 :: OBSERVED :: STABLE',
    'GARMENT_07 :: IN ROTATION :: STABLE',
    'GARMENT_08 :: FINAL OBSERVATION',
    'AMB.01 :: SIGNAL NOMINAL',
    'PERIMETER :: CLEAR',
    'SENSOR_02 :: RECALIBRATING',
    'FEED SYNC :: NOMINAL',
    'LIGHT LEVEL :: LOW :: NORMAL',
    'SYS :: NO ANOMALY',
    'TAG_HIVIS :: ACTIVE',
    'REFLECTIVE INTEGRITY :: 99.4%',
    'OBSERVATION WINDOW :: OPEN'
  ];

  const FEED_START = Date.now();
  const MAX_LOG_LINES = 4;
  const TICK_INTERVAL = 900;
  const WAVE_INTERVAL = 80;
  const PULSE_INTERVAL = 700;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function timestamp() {
    const d = new Date();
    return pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
  }

  function uptime() {
    const elapsed = Math.floor((Date.now() - FEED_START) / 1000);
    const h = Math.floor(elapsed / 3600);
    const m = Math.floor((elapsed % 3600) / 60);
    const s = elapsed % 60;
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  function pickRandom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function init() {
    const log = document.getElementById('wfsf-feed-log');
    const uptimeEl = document.getElementById('wfsf-feed-uptime');
    const dot = document.getElementById('wfsf-feed-dot');
    const wave = document.getElementById('wfsf-feed-wave');

    if (!log || !uptimeEl || !dot || !wave) return;

    const logLines = [];

    function pushLine(text, isHighlight) {
      const color = isHighlight ? 'var(--wfsf-yellow)' : 'var(--wfsf-text-dim)';
      const line = document.createElement('div');
      line.style.color = color;
      line.innerHTML = '<span style="color:var(--wfsf-text-ghost);">' + timestamp() + '</span> ' + text;
      logLines.push(line);
      log.appendChild(line);
      while (logLines.length > MAX_LOG_LINES) {
        const removed = logLines.shift();
        if (removed && removed.parentNode) removed.parentNode.removeChild(removed);
      }
    }

    for (let i = 0; i < MAX_LOG_LINES; i++) {
      pushLine(pickRandom(SYSTEM_LINES), false);
    }

    let tick = 0;
    setInterval(function() {
      tick++;
      if (tick % 3 === 0) {
        const isTruth = Math.random() < 0.22;
        if (isTruth) {
          pushLine(pickRandom(TRUTHS), true);
        } else {
          pushLine(pickRandom(SYSTEM_LINES), false);
        }
      }
    }, TICK_INTERVAL);

    setInterval(function() {
      uptimeEl.textContent = uptime();
    }, 1000);

    let pulseState = 0;
    setInterval(function() {
      pulseState = (pulseState + 1) % 2;
      dot.style.opacity = pulseState ? '1' : '0.3';
    }, PULSE_INTERVAL);

    const waveLength = 60;
    const wavePoints = [];
    for (let j = 0; j < waveLength; j++) wavePoints.push(12);

    setInterval(function() {
      const next = 12 + (Math.random() - 0.5) * 4 + Math.sin(Date.now() / 400) * 2;
      wavePoints.shift();
      wavePoints.push(next);
      let str = '';
      for (let k = 0; k < wavePoints.length; k++) {
        str += (k * 5) + ',' + wavePoints[k].toFixed(1) + ' ';
      }
      wave.setAttribute('points', str);
    }, WAVE_INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.WFSFFeed = { init: init };
})();